import Cookies from "universal-cookie";
import { API_URL } from "../../../constants/urlConstants";
import { post, put } from "axios";
import { baseUrl, getApiAsyn, getPythonApiAsyn, getApiAsynDownloadBlob, getPythonApiAsynDownloadBlob, basePYUrl } from "../../PostAPI";
import { APIError, handleAPIError } from "../../common/errorHandler";
import { extractData } from "../../utils";
import { downloadBlob } from "../../utils/download";
import { getDecoratedUrl } from "../../common/urlService";

const cookies = new Cookies();


export const fetchInvoice = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.INVOICES.FETCH_INVOICE,
    payload,
  });

  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
    // return extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const createInvoiceRecord = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.INVOICES.CREATE_INVOICE}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editInvoiceRecord = async (data) => {
  try {
    let result = await dataUploadApi(API_URL.INVOICES.EDIT_INVOICES, data.payload, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: cookies.get("authorization"),
    },
  };

  if (isEdit) {
    return put(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};

export const generateInvoiceBulk = async (payload) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: cookies.get("authorization"),
      },
    };
    const result = await post(`${basePYUrl}${API_URL.INVOICES.GENERATE_INVOICE_BULK}`, payload, config);
    return { isError: false, data: result.data };
  } catch (error) {
    console.error("Bulk generate invoice error:", error);
    return { isError: true, error: handleAPIError(error) };
  }
};

export const generateInvoice = async (payload) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: cookies.get("authorization"),
      },
    };
    const result = await post(`${basePYUrl}${API_URL.INVOICES.GENERATE_INVOICE}`, payload, config);
    if (result?.data?.isError) {
      throw new APIError(result.data);
    }
    return { isError: false, data: result.data };
  } catch (error) {
    console.error("Generate invoice error:", error);
    return { isError: true, error: handleAPIError(error) };
  }
};

export const fetchFuelCompanies = async () => {
  try {
    const result = await getPythonApiAsyn(API_URL.INVOICES.FETCH_FUEL_COMPANIES, cookies.get("authorization"));
    return result?.isError ? [] : result;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const fetchCompanyCustomers = async () => {
  try {
    const result = await getPythonApiAsyn(API_URL.INVOICES.FETCH_COMPANY_CUSTOMERS, cookies.get("authorization"));
    return result?.isError ? [] : result;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const fetchInvoiceById = async (payload) => {
  const url = `${API_URL.INVOICES.FETCH_BY_INVOICE_ID}view?invoiceId=${payload?.id}`;
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.status) {
      throw new APIError(result);
    }

    // result = extractData(result, !payload?.filters);
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const downloadInvoice = async (invoiceNumber, fileType = "PDF") => {
  const url = fileType === "CSV"
    ? `${API_URL.INVOICES.DOWNLOAD_INVOICE_CSV.replace(':invoiceNumber', invoiceNumber)}`
    : `${API_URL.INVOICES.DOWNLOAD_INVOICE_PDF.replace(':invoiceNumber', invoiceNumber)}`;

  try {
    const response = await getPythonApiAsynDownloadBlob(url, cookies.get('authorization'));
    if (response?.APIResult === 0) {
      throw new handleAPIError(response);
    }
    const mimeType = fileType === "CSV" ? "text/csv" : "application/pdf";
    const fileName = fileType === "CSV" ? "invoice.csv" : "invoice.pdf";
    downloadBlob(response, fileName, mimeType);
    return {
      isError: false,
      data: response,
    };
  } catch (error) {
    console.error(`${fileType.toUpperCase()} Download invoice error:`, error);
    return {
      isError: true,
      error: handleAPIError(error),
    };
  }
};

export const fetchInvoiceStatuses = async () => {
  const url = `${API_URL.INVOICES.FETCH_INVOICE_STATUSES}`;
  try {
    const result = await getPythonApiAsyn(url, cookies.get("authorization"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error("Error fetching invoice statuses:", error);
    return handleAPIError(error);
  }
};

export const sendInvoiceEmail = async (id) => {
  const url = API_URL.INVOICES.EMAIL_INVOICE.replace(":id", id);
  try {
    let result = await post(basePYUrl + url, {}, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: cookies.get("authorization"),
      },
    });

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error("Error sending invoice email:", error);
    return handleAPIError(error);
  }
};

export const sendMultipleInvoiceEmails = async (ids) => {
  const idParams = ids.map((id) => `ids=${id}`).join("&");
  const url = `${API_URL.INVOICES.BULK_EMAIL_INVOICES}&${idParams}`;
  try {
    let result = await post(basePYUrl + url, {}, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: cookies.get("authorization"),
      },
    });

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error("Error sending bulk invoice emails:", error);
    return handleAPIError(error);
  }
};

export const fetchInvoicePayments = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.INVOICES.FETCH_INVOICE_PAYMENTS,
    payload,
  });

  try {
    let result = await getApiAsyn(url, cookies.get("authorization"));
    if (result?.error) {
      throw new APIError(result);
    }
    return extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};


export const createInvoicePayment = async (payload) => { 
  try {
    const result = await dataUploadApi(
      `${API_URL.INVOICES.CREATE_INVOICE_PAYMENT}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchInvoicePaymentModeDD = async (payload) => {
  const url = API_URL.INVOICES.PAYMENT_MODE_DD;
  try {
    const result = await getApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }

    let res = result?.payment_mode_list || []; // adjust to your API shape
    res = res.map((item) => ({
      label: item.name,
      value: item.code,
    }));

    return { content: res };
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

